document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".fun-activity-4");

  sections.forEach((section) => {
    const cards = section.querySelectorAll(".fun-activity-4-card-item");
    const icons = section.querySelectorAll(".fun-activity-4-icon-item");
    const bgs = section.querySelectorAll(".fun-activity-4-bg-item");

    icons.forEach((icon, index) => {
      icon.addEventListener("click", () => {
        // Update Icons
        icons.forEach((i) => i.classList.remove("active"));
        icon.classList.add("active");

        // Update Cards
        cards.forEach((c) => c.classList.remove("active"));
        if (cards[index]) {
          cards[index].classList.add("active");
        }

        // Update Backgrounds
        bgs.forEach((b) => b.classList.remove("active"));
        if (bgs[index]) {
          bgs[index].classList.add("active");
        }
      });
    });
  });
});
